import { Component, Inject } from '@angular/core';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
    IConfig,
    IConfigForm,
    IConfigUpdatePayload,
} from '../config.interface';
import { ConfigService } from '../config.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-edit-config',
    templateUrl: './edit-config.component.html',
    styleUrls: ['./edit-config.component.scss'],
})
export class EditConfigComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        value: new FormControl(this.data.value, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IConfig,
        private dialogRef: MatDialogRef<EditConfigComponent>,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, value } = this.form.value as IConfigForm;
        const updateConfig: IConfigUpdatePayload = {
            id_configuration: this.data.id_configuration,
            name,
            value,
        };

        this.configService
            .updateConfig(updateConfig)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }
}
